<template>
  <div class="iDalgo-Player-Item">
    <div class="select">
      <!-- <div class="drag-el"></div> -->
    </div>
    <div class="content">
      <div v-if="!hasPlayers" class="user-picture"></div>
      <transition name="fade">
        <div v-if="hasPlayers" :style="{ 'background-image': 'url(' + player.tUrlPicture + ')' }" class="user-picture"></div>
      </transition>
      <div class="infos-player">
        <span v-if="!hasPlayers" class="info-player-empty text-empty"></span>
        <span v-if="hasPlayers" class="name-player">{{ playerName }}</span>
        <div>
          <img v-if="hasPlayers" :src="player.rCountryUrlPicture" class="country-picture" />
          <img v-if="hasPlayers && hasClub" :src="player.rTeamUrlPicture" class="club-picture" />
        </div>
        <span v-if="!hasPlayers" class="info-value-empty text-empty"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'iDalgo-Player-Item',
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      hasPlayers: 'players/hasPlayers',
      country: 'players/country'
    }),
    playerName () {
      if (this.player.tNickName === this.player.tName) {
        return `${this.player.tNickName} ${this.player.tFirstName.charAt(0)}.`
      }
      return `${this.player.tName} ${this.player.tFirstName.charAt(0)}.`
    },
    hasClub () {
      if (this.player.rCountryUrlPicture === this.player.rTeamUrlPicture) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    handleDelete () {
      this.$confirm(this.$t('iDalgoListEdit.deleteAlert.message'), this.$t('iDalgoListEdit.deleteAlert.message'), {
        confirmButtonText: this.$t('actions.delete'),
        cancelButtonText: this.$t('actions.cancelButton'),
        type: 'warning'
      }).then(() => {
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Player-Item {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 55px;
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid #E3E2E2;
  border-radius: 5px;
  background-color: #FFFFFF;
  cursor: move;

  .select {
    box-sizing: border-box;
    height: 18px;
    width: 18px;
    border-radius: 9px;
    border: 1px solid #979797;
    background-color: #F5F5F5;
    margin: 0px 10px 0px 15px;
    user-select: none;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    user-select: none;
  }

  .user-picture {
    margin: 0 $default_padding / 2;
    width: 35px;
    height: 35px;
    border-radius: $default_padding / 4;
    background-size: cover;
    user-select: none;
  }

  .infos-player {
    margin-left: 10px;
    user-select: none;
    .name-player {
      color: $color1;
      font-size: 14px;
      font-weight: bold;
      user-select: none;
    }
    .country-picture {
      height: 14px;
      width: 20px;
      border-radius: 2px;
      margin-right: 5px;
      user-select: none;
    }
    .club-picture {
      height: 14px;
      width: 20px;
      border-radius: 2px;
      user-select: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Player-Item.vue